export const socialsData = {
  github: "https://github.com/Uuttssaavv",
  linkedIn: "https://www.linkedin.com/in/theutsavg",
  // instagram: "https://www.instagram.com/theutsavg",
  // twitter: "https://twitter.com/theutsavg",
  medium: "https://medium.com/@theutsavg1",
  // youtube: "https://www.youtube.com/channel/UCsFe10xVXYt5QQVU8l0pPLw",
};
